module.exports = __webpack_public_path__ + "img/full3-min.3f78eff9.png";